import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

import { AppState } from "shared/data/reducers";
import { getTranslatedStay } from "shared/lib/translationOperations";

import FormattedMessage from "@components/UI/FormattedMessage";

type PassengerChangeCondition = {
  PassengerType: string;
  MinimumStay: {
    Stay: string;
    StayUnit: string;
  };
  MaximumStay: {
    Stay: string;
    StayUnit: string;
  };
  FlightCancelCondition: {
    Amount: string;
    AmountType: string;
  };
  FlightCancelConditionBeforeDeparture: {
    Amount: string;
    AmountType: string;
  };
  FlightCancelConditionAfterDeparture: {
    Amount: string;
    AmountType: string;
  };
  FlightChangeCondition: {
    Amount: string;
    AmountType: string;
  };
  FlightChangeConditionBeforeDeparture: {
    Amount: string;
    AmountType: string;
  };
  FlightChangeConditionAfterDeparture: {
    Amount: string;
    AmountType: string;
  };
};

type Props = {
  passengerChangeCondition: PassengerChangeCondition;
  allowedTravelerTypes: any[];
  currency: string;
  intl: any;
};

const AMOUNT_TYPE = "PERCENT";
const AMOUNT = "100";

function ChangeTicketPassengerDetail(props: Props) {
  const { passengerChangeCondition, currency } = props;
  const {
    FlightCancelCondition,
    FlightChangeCondition,
  } = passengerChangeCondition;
  const hideStay =
    FlightCancelCondition &&
    FlightCancelCondition.AmountType === AMOUNT_TYPE &&
    FlightCancelCondition.Amount === AMOUNT &&
    FlightChangeCondition &&
    FlightChangeCondition.AmountType === AMOUNT_TYPE &&
    FlightChangeCondition.Amount === AMOUNT;

  const minimumStay = getTranslatedStay({
    unit: passengerChangeCondition?.MinimumStay?.StayUnit,
    count: passengerChangeCondition?.MinimumStay?.Stay,
    intl: props.intl,
  });

  const maximumStay = getTranslatedStay({
    unit: passengerChangeCondition?.MaximumStay?.StayUnit,
    count: passengerChangeCondition?.MaximumStay?.Stay,
    intl: props.intl,
  });

  return (
    <div className="change-ticket-passenger-detail">
      <ul className="change-ticket-passenger-detail-ul">
        <div className="change-ticket-passenger-detail-title">
          {props.allowedTravelerTypes.find(
            (allowedTravelerType) =>
              allowedTravelerType.Code ===
              passengerChangeCondition.PassengerType
          )?.$t || passengerChangeCondition.PassengerType}
        </div>

        {!hideStay && passengerChangeCondition.MinimumStay && (
          <li className="change-ticket-passenger-detail-li">
            <FormattedMessage id="ChangeTicketPassengerDetail.minimumStay" />{" "}
            {minimumStay &&
              props.intl.formatMessage(
                { id: minimumStay },
                { count: passengerChangeCondition.MinimumStay.Stay }
              )}
          </li>
        )}
        {!hideStay && passengerChangeCondition.MaximumStay && (
          <li className="change-ticket-passenger-detail-li">
            <FormattedMessage id="ChangeTicketPassengerDetail.maximumStay" />{" "}
            {maximumStay &&
              props.intl.formatMessage(
                { id: maximumStay },
                { count: passengerChangeCondition.MaximumStay.Stay }
              )}
            <br />
          </li>
        )}

        {(passengerChangeCondition.FlightChangeConditionBeforeDeparture ||
          passengerChangeCondition.FlightChangeConditionAfterDeparture) && (
          <li className="change-ticket-passenger-detail-li">
            <div className="change-ticket-action-title">
              <FormattedMessage id="ChangeTicketPassengerDetail.flightChangeCondition" />
            </div>

            {passengerChangeCondition.FlightChangeConditionBeforeDeparture && (
              <div className="change-ticket-passenger-detail-condition">
                <FormattedMessage id="Result.beforeDeparture" />
                &nbsp;-&nbsp;
                {
                  passengerChangeCondition.FlightChangeConditionBeforeDeparture
                    .Amount
                }{" "}
                {passengerChangeCondition.FlightChangeConditionBeforeDeparture
                  .AmountType === AMOUNT_TYPE
                  ? "%"
                  : currency}
              </div>
            )}

            {passengerChangeCondition.FlightChangeConditionAfterDeparture && (
              <div className="change-ticket-passenger-detail-condition">
                <FormattedMessage id="Result.afterDeparture" />
                &nbsp;-&nbsp;
                {
                  passengerChangeCondition.FlightChangeConditionAfterDeparture
                    .Amount
                }{" "}
                {passengerChangeCondition.FlightChangeConditionAfterDeparture
                  .AmountType === AMOUNT_TYPE
                  ? "%"
                  : currency}
              </div>
            )}
          </li>
        )}

        <br />

        {(passengerChangeCondition.FlightCancelConditionBeforeDeparture ||
          passengerChangeCondition.FlightCancelConditionAfterDeparture) && (
          <li className="change-ticket-passenger-detail-li">
            <div className="change-ticket-action-title">
              <FormattedMessage id="ChangeTicketPassengerDetail.flightCancelCondition" />
            </div>

            {passengerChangeCondition.FlightCancelConditionBeforeDeparture && (
              <div className="change-ticket-passenger-detail-condition">
                <FormattedMessage id="Result.beforeDeparture" />
                &nbsp;-&nbsp;
                {
                  passengerChangeCondition.FlightCancelConditionBeforeDeparture
                    .Amount
                }{" "}
                {passengerChangeCondition.FlightCancelConditionBeforeDeparture
                  .AmountType === AMOUNT_TYPE
                  ? "%"
                  : currency}
              </div>
            )}

            {passengerChangeCondition.FlightCancelConditionAfterDeparture && (
              <div className="change-ticket-passenger-detail-condition">
                <FormattedMessage id="Result.afterDeparture" />
                &nbsp;-&nbsp;
                {
                  passengerChangeCondition.FlightCancelConditionAfterDeparture
                    .Amount
                }{" "}
                {passengerChangeCondition.FlightCancelConditionAfterDeparture
                  .AmountType === AMOUNT_TYPE
                  ? "%"
                  : currency}
              </div>
            )}
          </li>
        )}
      </ul>
    </div>
  );
}

export default connect((state: AppState) => ({
  currency: state.price.currency,
  allowedTravelerTypes: state.requestorConfig.allowedTravelerTypes,
}))(injectIntl(ChangeTicketPassengerDetail));
